import { BLOCK_TRADE_REGISTRATION_FUTURES_PATH } from '../constants';

export const isFuturesBlockTradesRegistration = () =>
  window.location.href.includes(BLOCK_TRADE_REGISTRATION_FUTURES_PATH);
